<div class="fadeIn">
  <div class="clearfix">
    <a *ngIf="userHasPassword && activePanel === 'intro'" class="btn btn-link pull-left" href="javascript:void(0)"
      (click)="showPasswordLogin()">
      <i class="icon">chevron_left</i>
      {{ appCopy.panelHeader['typePasswordText'+selectedLanguage] }}
    </a>
    <a *ngIf="activePanel !== 'intro'" class="btn btn-link pull-left" href="javascript:void(0)"
      (click)="activePanel = 'intro'">
      <i class="icon">chevron_left</i>
      {{ appCopy.panelHeader['goBackLink'+selectedLanguage] }}
    </a>
    <a class="btn btn-link pull-right" href="javascript:void(0)" (click)="handleCloseOverlay()">
      {{ appCopy.panelHeader['skipText'+selectedLanguage] }}
    </a>
  </div>

  <div class="fadeIn" *ngIf="activePanel === 'intro'">
    <h3>{{ appCopy.panelHeader['dontKnowYourPasswordText'+selectedLanguage] }}</h3>
    <p class="margin-bottom-16">{{ appCopy.panelHeader['noProblemText'+selectedLanguage] }}</p>

    <button *ngIf="userHasPhoneNumber" type="button" class="btn btn-primary btn-lg btn-block margin-bottom-16"
      (click)="sendVerifySms()">
      <div class="loader-container-btn" *ngIf="showVerifySmsLoader">
        <div class="loader loader--white">
          <svg class="circular" viewBox="25 25 50 50">
            <circle class="path" cx="50" cy="50" r="20" />
          </svg>
        </div>
      </div>
      {{ appCopy.panelHeader['sendCopyToPhoneButton'+selectedLanguage] }}
    </button>
    <button type="button" class="btn btn-primary btn-lg btn-block margin-bottom-16" (click)="sendMagicLink()">
      <div class="loader-container-btn" *ngIf="showMagicLinkLoader">
        <div class="loader loader--white">
          <svg class="circular" viewBox="25 25 50 50">
            <circle class="path" cx="50" cy="50" r="20" />
          </svg>
        </div>
      </div>
      {{ appCopy.panelHeader['sendEmailButton'+selectedLanguage] }}
    </button>
  </div>

  <div class="fadeIn" *ngIf="activePanel === 'sms'">
    <h3>{{ appCopy.panelHeader['smsSentText'+selectedLanguage] }}</h3>
    <p class="margin-bottom-16">
      {{ appCopy.panelHeader['codeSentToPhoneText'+selectedLanguage] }}
      <span class="text-primary">*** {{ phoneNumber }}</span>
    </p>
    <div class="panel panel-default panel--shadow">
      <div class="panel-heading bg-primary-light">{{ appCopy.panelHeader['enterCodeLabel'+selectedLanguage] }}
      </div>
      <div class="panel-body">
        <form #formSmsCode="ngForm" name="formSmsCode" novalidate>
          <div class="form-group code-inputs flex flex-always flex--space-evenly">
            <input class="form-control" id="digit1" name="digit1" type="number" min="0" max="9" #digit1="ngModel"
              autocomplete="off" [ngModel]="smsCode.digit1" required appCheckEmpty [appAutoTab]="1"
              (keyup)="handleDigitChange($event.target.value, 1)">
            <input class="form-control" id="digit2" name="digit2" type="number" min="0" max="9" #digit2="ngModel"
              autocomplete="off" [ngModel]="smsCode.digit2" required appCheckEmpty [appAutoTab]="1"
              (keyup)="handleDigitChange($event.target.value, 2)">
            <input class="form-control" id="digit3" name="digit3" type="number" min="0" max="9" #digit3="ngModel"
              autocomplete="off" [ngModel]="smsCode.digit3" required appCheckEmpty [appAutoTab]="1"
              (keyup)="handleDigitChange($event.target.value, 3)">
            <input class="form-control" id="digit4" name="digit4" type="number" min="0" max="9" #digit4="ngModel"
              autocomplete="off" [ngModel]="smsCode.digit4" required appCheckEmpty
              (keyup)="handleDigitChange($event.target.value, 4)">
          </div>
        </form>
      </div>
    </div>
    <p *ngIf="!showVerifyCodeBtn" class="text-center fadeIn">
      <a class="link" href="javascript:void(0)" (click)="sendVerifySms()">
        <div class="loader-container-btn" *ngIf="showVerifySmsLoader">
          <div class="loader">
            <svg class="circular" viewBox="25 25 50 50">
              <circle class="path" cx="50" cy="50" r="20" />
            </svg>
          </div>
        </div>
        <span *ngIf="!showVerifySmsLoader">{{ appCopy.panelHeader['sendCodeAgainText'+selectedLanguage]
          }}</span>
      </a>
    </p>
    <button *ngIf="showVerifyCodeBtn" type="button" class="btn btn-primary btn-lg btn-block margin-bottom-16 fadeIn"
      (click)="validateSmsCode()">
      <div class="loader-container-btn" *ngIf="showValidateCodeLoader">
        <div class="loader loader--white">
          <svg class="circular" viewBox="25 25 50 50">
            <circle class="path" cx="50" cy="50" r="20" />
          </svg>
        </div>
      </div>
      {{ appCopy.panelHeader['bookFromText'+selectedLanguage] }} {{showCurrencyWithPrice}}
    </button>
  </div>

  <div class="fadeIn text-center" *ngIf="activePanel === 'email'">
    <h3>{{ appCopy.panelHeader['checkEmailText'+selectedLanguage] }}</h3>
    <p class="margin-bottom-16">
      {{ appCopy.panelHeader['emailJustSentText'+selectedLanguage] }}<br>
      <span class="text-primary">{{ userEmail }}</span>
    </p>
    <p class="margin-bottom-16">{{ appCopy.panelHeader['completeYourOrderText'+selectedLanguage] }}</p>
    <p class="text-center">
      <a class="link" href="javascript:void(0)" (click)="sendMagicLink()">
        <div class="loader-container-btn" *ngIf="showMagicLinkLoader">
          <div class="loader">
            <svg class="circular" viewBox="25 25 50 50">
              <circle class="path" cx="50" cy="50" r="20" />
            </svg>
          </div>
        </div>
        <span *ngIf="!showMagicLinkLoader">{{ appCopy.panelHeader['sendEmailButton'+selectedLanguage] }}</span>
      </a>
    </p>
  </div>
</div>
